export default __webpack_public_path__ + "static/media/tempStore5.21086137.png";